export const folderTooltips = {
    config: 'The config contains preference settings, the site map, profiles, template, color theme, and other useful items.',
    display: 'The item display config controls how vehicle information will display in listings, pricing, vehicle titles, etc.',
    facet: 'The facet config controls how users can filter results on listings pages.',
    itemlists: 'Some widgets, like newer versions of the button block, hold information in a list of items rather than many preferences. These can be found here.',
    labels: 'Labels control text on the site that has been modified',
    navigations: 'Navigations control which links or widgets appear inside a navigation.',
    pages: 'Pages files control the layout and order of widgets on a page.',
    sitecontent: 'The customizable content that shows in dealer editable areas.',
    slideshows: 'Slideshow files control the images and their links that appear in slideshows.'
}
export const helpLink = 'https://ghe.coxautoinc.com/DDC-WebPlatform/dvs-web/blob/master/README.md'
